<template>
  <v-app id="inspire">
  <div class="container" >
    <v-flex xs12 sm6 offset-sm3 v-if="formStatus != 2">
      <v-card class="innerContainer">
        <v-card-title class="blue white--text">
          <span class="headline">Accept Offer and Request Contract Form</span>
            
          <flash-message class="myCustomClass" id="myCustomClass"></flash-message>
    
          <v-spacer></v-spacer>
          {{offer.deal_name}}
        </v-card-title>
        <v-card-text v-if="formStatus === 0">
          <v-form onSubmit="return false;"  ref="form" lazy-validation>
                      <p>Business Name: {{business_name}}</p>
                      <p>Position Number: {{offer.lender_position_number}}</p>
                      <p>Offer Amount: {{offer.lender_offer_amount |currency}}</p>
                      <p>Payback Amount: {{offer.lender_payback_amount |currency}}</p>
                      <p>Max Upsell: {{offer.lender_factor_rate}}</p>
                      <p>Fee Split: {{offer.fee_split_percent == null ? 0 : offer.fee_split_percent}}%</p>
                      <p>ISO Commission Amount: {{offer.lender_commission_amt |currency}}</p><br/>
                      
                      
                      <!--Test-->
                      <v-flex class="pr-3">
                        <label><b>ISO Commission %</b></label>
                        <v-slider
                          v-model="slider"
                          :max="max"
                          :min="min"
                          :label="slider"
                          thumb-label="always"
                          prefix='%'
                          v-on:change="calculatePayment"
                        ></v-slider>
                      </v-flex>
                      <!--Test-->
                      
                      <p>Buy Rate: {{offer.lender_buy_rate}}</p>
                      <p>Payment: {{offer.lender_payment |currency}} {{offer.lender_payment_type}} </p>
                      <p>Term: {{offer.lender_term}} Days</p>
                      <p >Note: <span v-html="offer.offer_notify_note"></span></p>
                  
                  <v-flex xs12 sm12 md12>
                    <p>You may respond to this email with any questions, or stips:</p>
                    <div class="large-12 medium-12 small-12 filezone">
                      <input type="file" id="files" ref="files" style="margin-left: -270px;" multiple v-on:input="handleFiles()" />
                      <p>
                        Drop your files here <br>or click to search
                      </p>
                    </div>
          
                    <div v-for="(file, key) in files" class="file-listing " :key="key">
                        
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6>
                        <img class="preview" v-bind:ref="'preview'+parseInt(key)" height="70" width="100"/>
                        <p>{{file.fileUploaded.name}}</p>
                        
                        </v-flex>
                        
                        <v-flex xs12 sm6 md6>
                          <v-autocomplete
                            v-model="file.category_id"
                            :rules="[v => !!v || 'File Category is required']"
                            :items="categories"
                            item-text="file_category_name"
                            item-value="id"
                            label2="File Category"
                            persistent-hint
                            required
                            autocomplete
                          ></v-autocomplete>
                        </v-flex>  
                      
                      </v-layout>
                        
                        <div class="success-container" v-if="file.id > 0">
                          Success
                        </div>
                        <div class="remove-container" v-else>
                          <a class="remove" v-on:click="removeFile(key)">Remove</a>
                        </div>
            
                    </div>
          
                  </v-flex>
                  <!--Files Upload-->
                  
                  <div class="col-md-12">
                      <vue-editor id="note" placeholder="How would you like to receive contracts? Send E-Sign directly to merchant(s) or Email as attachment?" v-model="iso_message" :editorToolbar="customToolbar"></vue-editor>
                  </div>


                  <!-- offer.lender_payback_amount -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        small
                        v-on="on"
                        @click.prevent="()=>{}"
                        v-if="offer.lender_offer_status == 'Offer Accepted' || offer.lender_offer_status == 'Offer Accepted (Old)'"
                      >Submit</v-btn>
                    </template>
                    <span>
                     This offer has been accepted, no additional change can be made at this moment.
                    </span>
                  </v-tooltip>
                  <v-btn v-if="!(offer.lender_offer_status == 'Offer Accepted' || offer.lender_offer_status == 'Offer Accepted (Old)')" color="primary" @click="sendNotification" :disabled="progressModel">
                    Submit
                  </v-btn>
                   
      
            </v-form>
          <!--<progress-model v-if="progressModel"></progress-model>-->
        </v-card-text>
        <v-card-text v-if="formStatus === 1">
          <p>Your contract request has been processed. We will get back to you shortly.</p>
          <br>
          <p>Thank you,</p>
          <!-- <v-btn color="primary" @click="logout">
              DONE
          </v-btn> -->
        </v-card-text>
        <v-card-text v-if="formStatus === 4">
          <p><span class="material-icons">error_outline</span> This offer was already accepted for contract. Please reply through the email for any change/question.</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <div class="text-xs-center" v-if="formStatus === 2">
      <v-flex>
        <span class="material-icons">error_outline</span> <p><b>Sorry, Page not found.</b></p>
      </v-flex>
    </div>
    <div class="text-xs-center" v-if="formStatus === 4">
      <v-flex>
        <span class="material-icons">error_outline</span> <p><b>You can't reply more than once.</b></p>
      </v-flex>
    </div>
    
    
     <div class="text-xs-center">
    <v-dialog v-model="progressModel" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
      
</div>

</v-app>
</template>

<script>
  // Basic Use - Covers most scenarios
  import axios from 'axios';
  import ProgressModel from './ProgressModel';
  import GeneralHelper from './helpers/general_helper';
  import {VueEditor} from 'vue2-editor';
  import {URL} from '../../env'

  export default {
    mixins: [GeneralHelper],
    components: {
      VueEditor,
    },

    data() {
      return {
        formStatus: 0,
        deal: {},
        min: 1,
        max: 0,
        slider: 'ISO Commission %',
        user: {
          id: null,
        },
        progressModel: false,
        uploaded: false,
        category_id: null,
        business_name: null,
        files: [],
        categories: [],
        iso_message: '',
        image: '',
        uploadedFiles:'',
        offer: {},
        // Set Custom toolbar for vue editor
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ header: 1 }, { header: 2 }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        [{ direction: "rtl" }],
        ["clean"]
      ],
      }
    },
    created(){
      this.getLenderData();
      this.business_name = this.$route.query.business_name
    },
    mounted() {     
      
    },
  
    methods: {
      getLenderData(){
        if(!this.$route.query.unique_id){
          this.formStatus = 2;
          return false
        }
        axios.get(`${URL}/api/get_lender_data/${this.$route.query.unique_id}`).then(resp => {
          if(resp.data.length > 0){
            this.offer = resp.data[0]
            // this.deal.deal_lender_id = resp.data[0].id
            this.max = resp.data[0].lender_commission_percentage
            this.slider = resp.data[0].lender_commission_percentage
            this.formStatus = resp.data[0].iso_reply == 1 ? 4 : 0;
          }
          this.getCategories()
        })
      },
      async getCategories () {
        await axios.get(`${URL}/api/get_stip_file_category`, {
          params: {
            deal_id: this.offer.deal_id
          }
        }).then(res => {
          // this.categories = res.data.filter(res => res.file_category_name.toUpperCase() === 'VOIDED CHECK' || res.file_category_name.toUpperCase() === 'VOID CHECK' || res.file_category_name.toUpperCase() === 'DRIVERS LICENSE' || res.file_category_name.toUpperCase() === 'DRIVER LICENSE' );
          this.categories = res.data
        });
      },
      handleFiles() {
        let uploadedFiles = this.$refs.files.files;
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push({fileUploaded: uploadedFiles[i], category_id: null});
        }
        this.getImagePreviews();
      },

      //handle image preview
      getImagePreviews() {
        for (let i = 0; i < this.files.length; i++) {
          if (/\.(jpe?g|png|gif)$/i.test(this.files[i].fileUploaded.name)) {
            let reader = new FileReader();
            reader.addEventListener("load", function() {
              this.$refs['preview' + parseInt(i)][0].src = reader.result;
            }.bind(this), false);
            reader.readAsDataURL(this.files[i].fileUploaded);
          }
          else {
            this.$nextTick(function() {
              this.$refs['preview' + parseInt(i)][0].src = 'https://www.foot.com/wp-content/uploads/2017/03/placeholder.gif';
            });
          }
        }
      },
      //Remove file
      removeFile(key) {
        this.files.splice(key, 1);
        this.getImagePreviews();
      },
      //Method to submit merchant files
      async submitFiles() {
        let vm = this;
        // if(vm.files.length > 0){
        if (this.$refs.form.validate()) {
            let deal_file_ids = []

            for (let i = 0; i < vm.files.length; i++) {
              if (vm.files[i].fileUploaded.id) {
                continue;
              }
              let formData = new FormData();
              formData.append('file', vm.files[i].fileUploaded);
              formData.append('user_id', vm.$route.query.iso_user_id);
              formData.append('deal_id', vm.offer.deal_id);
              formData.append('file_category_id', vm.files[i].category_id);
              formData.append('notify_underwriter', 'OFF');

              // await this.$store.dispatch('deals/createDealFiles', {formData, headers: {}})
              await axios.post(`${URL}/api/create_funding_package`, formData)
              .then((data)=> {
                if(data.data&&data.data.success&&data.data.success.id){
                  deal_file_ids.push(data.data.success.id)
                }
                // if(vm.files.length==i+1){
                //    axios.post('/api/iso_accept_offer_noti', {
                //     deal_id: vm.offer.deal_id,
                //     deal_file_ids: deal_file_ids,
                //     deal_lender_id: vm.offer.id,
                //     iso_message: vm.iso_message,
                //   })
                // }
               
                if (data.data.success) {
                  vm.flash(data.data.message, 'success',{timeout: 3000});
                  vm.uploaded = true;
                }
              })
            }
            axios.post(`${URL}/api/iso_accept_offer_noti`, {
              deal_id: vm.offer.deal_id,
              deal_file_ids: deal_file_ids,
              deal_lender_id: vm.offer.id,
              iso_message: vm.iso_message,
            })
            vm.files = [];
            vm.saveUpdateSubmission();
        }
      // }else{
      //   vm.saveUpdateSubmission();
      // }

    },
    async saveOfferUpdate () {
        let app = this;
        // app.$store.dispatch('deals/submissions/updateDealLenders', {
        await axios.patch(`${URL}/api/update_deal_lender/`+ app.offer.id, {
            id: app.offer.id,
            deal_id: app.offer.deal_id,
            lender_offer_status: 'Offer Accepted',
            lender_commission_amt: app.offer.lender_commission_amt,
            lender_offer_amount: app.offer.lender_offer_amount,
            lender_payback_amount: app.offer.lender_payback_amount,
            lender_payment: app.offer.lender_payment,
            lender_factor_rate: app.offer.lender_factor_rate,
            lender_buy_rate: app.offer.lender_buy_rate,
            lender_commission_percentage: app.slider,
            lender_term: app.offer.lender_term,
        }).then(function(response) {
          if (response.data.success) {
            app.flash(response.data.message, 'success',{timeout: 3000});
            app.submitFiles();
        }
        }).catch(function(error) {
          app.flash('There was an error', 'error',{timeout: 3000});
        });
          // this.updateSubmissionById({
        await axios.patch(`${URL}/api/update_submission/`+ this.offer.deal_id,{
          id: app.offer.deal_id,
          deal_status: 'Contract Request',
          deal_next_processor_role: 'Underwriter Assistant',
        }).then(resp => {
          axios.post(`${URL}/api/addContractSheetRowWithData`,{
            deal_id: app.offer.deal_id,
          })
        })


        // await axios.patch('/api/insert_contract_request',{
        //   deal_id: app.offer.deal_id,
        //   offer_id: app.offer.id,
        //   user_id: app.$route.query.iso_user_id,
        //   notes: vm.iso_message
        // })
      },
      
       sendNotification () {
          let vm = this;
          vm.progressModel = true;
          // axios.post('/api/iso_accept_offer_noti', {
          //   deal_id: vm.offer.deal_id,
          //   deal_lender_id: vm.offer.id,
          //   iso_message: vm.iso_message,
          // })
          vm.saveNote();
        },
        
     //Save Form
    saveNote () {
        let app = this;
        axios
          .post(`${URL}/api/create_sub_note`, {
            deal_id: app.offer.deal_id,
            user_id: app.$route.query.iso_user_id,
            deal_user_note: app.iso_message,
            deal_note_type: "Offer",
          }).then(function(response) {
              app.saveActivity();
          }).catch(function(error) {
            app.flash('Error Adding Note', 'error',{timeout: 3000})
          });
        },
        
    //Save Form
    saveActivity () {
        let app = this;
        axios
          .post(`${URL}/api/create_sub_note`, {
            deal_id: app.offer.deal_id,
            user_id: app.$route.query.iso_user_id,
            deal_user_note:'Offer Accepted',
            deal_note_processor_role: app.user.role,
            deal_note_type: "Activity",
            pinned: false,
          }).then(function(response) {
              app.saveOfferUpdate();
          }).catch(function(error) {
            app.flash('Error Adding Note', 'error', {
              timeout: 3000
            })
          })
        },
      
      //Save Form
    async saveUpdateSubmission () {
      try {
        // const resp = await this.updateSubmissionById({
        const resp = await axios.patch(`${URL}/api/update_submission/`+ this.offer.deal_id,{
          id: this.offer.deal_id,
          user_id: 0,
          deal_status: 'Contract Request',
          deal_next_processor_role: 'Underwriter Assistant',
        })
        if (resp) {
          // await this.$store.dispatch("deals/addContractSheetRowWithData",{
          await axios.post(`${URL}/api/addContractSheetRowWithData`,{
            deal_id: this.offer.deal_id,
          })
          this.progressModel = false;
          this.formStatus = 1;
          // this.logout();
          this.flash(resp.data.message, "success", {
            timeout: 3000
          });
        }
      } catch (error) {
        this.flash(resp.data.message, "error", {
          timeout: 3000
        });
        this.progressModel = false;
      }
    },
      
      calculatePayment(){
        let app = this;
        if(app.offer.lender_factor_rate.length > 0){
          let commission_percentage = (app.slider / 100).toFixed(2);
          let factor_rate = (+app.offer.lender_buy_rate + +commission_percentage).toFixed(2);
          app.offer.lender_factor_rate = factor_rate;
          let payback_amount = factor_rate * app.offer.lender_offer_amount;
            app.offer.lender_payback_amount = payback_amount;
          if(app.offer.lender_payment_type.toUpperCase() == 'DAILY'){ 
            app.offer.lender_payment = (payback_amount / app.offer.lender_term).toFixed(2);
          }else if(this.offer.lender_payment_type.toUpperCase() == 'WEEKLY'){
            app.offer.lender_payment = (payback_amount / app.offer.lender_term * 5).toFixed(2);
          }
        }
        this.calculateIsoCommissionAmount()
      }, 
      calculateIsoCommissionAmount(){
        this.offer.fee_split_percent = this.offer.fee_split_percent == null ? 0 : this.offer.fee_split_percent;
        let commission_percentage = (this.slider / 100).toFixed(2);
        this.offer.lender_commission_amt = (parseFloat(this.offer.lender_offer_amount)  * ((parseFloat(this.offer.fee_split_percent)/100) + parseFloat(commission_percentage))).toFixed(2)
      
      }

    }

  }
</script>


<style scoped>
  .innerContainer {
    overflow: hidden;
    overflow-y: scroll;
    height: 800px;
  }
  input[type="file"] {
    opacity: 0;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .filezone {
    outline: 2px dashed #2196F3;
    outline-offset: -10px;
    /*background: #ccc;*/
    background: #FAFAFA;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .filezone:hover {
    background: #EEEEEE;
  }

  .filezone p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 50px 50px 50px;
  }

  div.file-listing img {
    max-width: 90%;
  }

  div.file-listing {
    margin: auto;
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }

  div.file-listing img {
    height: 100px;
  }

  div.success-container {
    text-align: center;
    color: green;
  }

  div.remove-container {
    text-align: center;
  }

  div.remove-container a {
    color: red;
    cursor: pointer;
  }

  a.submit-button {
    display: block;
    margin: auto;
    text-align: center;
    width: 200px;
    padding: 10px;
    text-transform: uppercase;
    background-color: #CCC;
    color: white;
    font-weight: bold;
    margin-top: 20px;
  }
</style>


<style scoped>
  .fileUpload {
    position: relative;
    overflow: hidden;
    margin: 25px;
  }

  .fileUpload input.upload {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    padding: 0;
    font-size: 20px;
    cursor: pointer;
    opacity: 0;
    filter: alpha(opacity=0);
  }
</style>
